// TODO: Client Msg로 바꿔야 함
const PRODUCT_ERROR_CODE = {
  PRODUCT_001: 'PRODUCT001',
  PRODUCT_002: 'PRODUCT002',
  PRODUCT_003: 'PRODUCT003',
  PRODUCT_004: 'PRODUCT004',
  PRODUCT_005: 'PRODUCT005',
  PRODUCT_006: 'PRODUCT006',
  PRODUCT_007: 'PRODUCT007',
  PRODUCT_008: 'PRODUCT008',
  PRODUCT_009: 'PRODUCT009',
  PRODUCT_010: 'PRODUCT010',
  PRODUCT_011: 'PRODUCT011',
  PRODUCT_012: 'PRODUCT012',
};

const PRODUCT_ERROR_MESSAGE = {
  [PRODUCT_ERROR_CODE.PRODUCT_001]: '유효하지 않은 상품 ID 입니다.',
  [PRODUCT_ERROR_CODE.PRODUCT_002]: '상품 명 최대 글자 수(50자)를 초과 하였습니다.',
  [PRODUCT_ERROR_CODE.PRODUCT_003]: '상품 상태값을 확인해주세요.',
  [PRODUCT_ERROR_CODE.PRODUCT_004]: '유효하지 않은 카테고리 ID 입니다.',
  [PRODUCT_ERROR_CODE.PRODUCT_005]: '유효하지 않은 브랜드 ID 입니다.',
  [PRODUCT_ERROR_CODE.PRODUCT_006]: '브랜드 상태를 확인 해주세요.',
  [PRODUCT_ERROR_CODE.PRODUCT_007]: '브랜드명 최대 글자 수(100자)를 초과 하였습니다.',
  [PRODUCT_ERROR_CODE.PRODUCT_008]: '유효하지 않은 정렬 필드입니다.',
  [PRODUCT_ERROR_CODE.PRODUCT_009]: '유효하지 않은 정렬 순서입니다.',
  [PRODUCT_ERROR_CODE.PRODUCT_010]: '존재하지 않은 상품 ID입니다.',
  [PRODUCT_ERROR_CODE.PRODUCT_011]: '상품 ID 는 필수 값 입니다.',
  [PRODUCT_ERROR_CODE.PRODUCT_012]: '상품 ID는 숫자만 입력해주세요.',
};

export default PRODUCT_ERROR_MESSAGE;
